import React, { useState } from "react";
import { Link, useHistory  } from "react-router-dom";
import { Row, Col, Form, Input, Button, message } from "antd";
import PasswordStrengthBar from 'react-password-strength-bar';
import AuthService from "../../../../service/auth.service";
import LeftContent from "../leftContent";

export default function SignUp() {
  let history = useHistory();
  const [form] = Form.useForm();
  const [password, setPassword] = useState("");

  const onChangePassword = (e) => {
	  const passwordx = e.target.value;
	  setPassword(passwordx);
	};

  const handleSignUp = async (values) => {
    const { name, email, password, password2 } = values;
    const postData = {
      name,
      email,
      password,
      password2
    };

    try {
      // Validate password and confirm password match
      if (password !== values.password2) {
        message.error("Password and confirm password do not match");
        return;
      }

      // Validate email domain is orevan.org
      if (!email.endsWith("@orevan.org")) {
        message.error("Please use an email with orevan.org domain");
        return;
      }

      AuthService.register(name, email, password, password2).then(
        () => {
          form.resetFields();
          history.push("/");
          window.location.reload();
        },
        (error) => {
          const resMessage =
            (error.response &&
            error.response.data &&
            error.response.data.message) ||
            error.message ||
            error.toString();
          console.log("Registration error:", resMessage)
          message.error("Registration failed");
        }
      );
      
    } catch (error) {
      console.error("Registration error:", error.response);
      message.error("Registration failed");
    }
  };

  return (
    <Row gutter={[32, 0]} className="hp-authentication-page">
      <LeftContent />
      <Col md={12}>
        <Row className="hp-h-100" align="middle" justify="center">
          <Col
            xxl={11}
            xl={15}
            lg={20}
            md={20}
            sm={24}
            className="hp-px-sm-8 hp-pt-24 hp-pb-48"
          >
            <h1>Create Account</h1>
            <Form
              form={form}
              layout="vertical"
              name="basic"
              className="hp-mt-sm-16 hp-mt-32"
              onFinish={handleSignUp}
            >
              <Form.Item
                label="Name:"
                name="name"
                rules={[
                  { required: true, message: "Please enter your name" },
                ]}
              >
                <Input placeholder="Enter your name"/>
              </Form.Item>
              <Form.Item
                label="E-mail:"
                name="email"
                rules={[
                  { required: true, message: "Please enter your email" },
                ]}
              >
                <Input placeholder="Enter your you@orevan.org"/>
              </Form.Item>
              <Form.Item
                label="Password:"
                name="password"
                rules={[
                  { required: true, message: "Please enter your password" },
                ]}
              >
                <Input.Password onChange={onChangePassword} placeholder="Password"/>
                <PasswordStrengthBar password={password} />
              </Form.Item>
              <Form.Item
                label="Confirm Password:"
                name="password2"
                rules={[
                  { required: true, message: "Please confirm your password" },
                ]}
              >
                <Input.Password placeholder="Confirm Password"/>
              </Form.Item>
              <Form.Item className="hp-mt-16 hp-mb-8">
                <Button block type="primary" htmlType="submit">
                  Sign up
                </Button>
              </Form.Item>
            </Form>
            <div className="hp-form-info">
              <span className="hp-text-color-black-80 hp-text-color-dark-40 hp-caption hp-mr-4">
                Already have an account?
              </span>
              <Link
                to="/"
                className="hp-text-color-primary-1 hp-text-color-dark-primary-2 hp-caption"
              >
                Login
              </Link>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
